<div
  class="input-box"
  [ngClass]="{
    hasError: formControl.invalid && formControl.touched,
    hasHint: !!(hint && hint.trim())
  }"
  [matTooltip]="getErrorMessage(formControl)"
  matTooltipPosition="right"
  [matTooltipDisabled]="formControl.valid || !formControl.touched"
>
  <mat-form-field>
    <mat-label
      >{{ placeholder }}
      <span *ngIf="required" class="required">*</span></mat-label
    >

    <textarea
      matInput
      [rows]="rows"
      [formControl]="formControl"
      [value]="formControl.value"
      [readonly]="disabled"
      [attr.maxlength]="maxlength">
    </textarea>
    <mat-hint *ngIf="hint && hint.trim()">{{ hint }}</mat-hint>
  </mat-form-field>
</div>
